import { jsx } from 'react/jsx-runtime';
import { forwardRef, useContext } from 'react';
import Textarea from './TextArea.js';
import FormContext from '../Form/FormContext.js';

const WithFormAutoComplete = forwardRef((props, ref) => {
    const contextProps = useContext(FormContext);
    return jsx(Textarea, Object.assign({ ref: ref }, contextProps, props));
});

export { WithFormAutoComplete as default };
